import { ASSOCIACAO_VINCULO_STATUS_OPTIONS } from './associacaoVeiculoFilterConfig';

export const associacaoTabelaFilterConfig = [
  {
    id: 'Id',
    type: 'text',
    label: 'Id',
    placeholder: 'Filtrar por id'
  },
  {
    id: 'Nome',
    type: 'text',
    label: 'Nome',
    placeholder: 'Filtrar por nome'
  },
  {
    id: 'Segmento',
    type: 'searchSelect',
    label: 'Segmento',
    placeholder: 'Selecione um ou mais segmentos',
    isMulti: true,
    showSelectAll: true,
    options: []
  },
  {
    id: 'StatusVinculo',
    type: 'select',
    label: 'Status Vínculo',
    placeholder: 'Selecione...',
    options: ASSOCIACAO_VINCULO_STATUS_OPTIONS
  }
];
